import React from 'react';
import PropTypes from 'prop-types';
import KluwellAdmin from './KluwellAdmin';
import SchoolCoordinator from './SchoolCoordinator';
import Teacher from './Teacher';
import Parent from './Parent';
import Reader from './Reader';

export default class Routes extends React.Component {
  static propTypes = {
    role: PropTypes.string.isRequired,
  };

  render() {
    const {role} = this.props;
    return React.createElement(
      {
        kluwell_admin: KluwellAdmin,
        school_coordinator: SchoolCoordinator,
        teacher: Teacher,
        parent: Parent,
        reader: Reader,
      }[role],
    );
  }
}
